module.exports = __webpack_public_path__ + "img/greenhouse.2faf5877.png";